import { Component, HostBinding } from '@angular/core';
import { Router } from '@angular/router';

import { ColorSchemeService } from '../../color-scheme.service';

import {
  DashboardStore,
  SalesLeaderboardColumn,
  SalesLeaderboardRole,
  SALES_LEADERBOARD_COLUMNS,
  salesLeaderboardRoles,
  salesLeaderboardSortKeys,
} from '../dashboardv2.store';
import { DashboardSalesLeaderboardStore } from '../stores';

import { buildSalesLeaderboardDrillDownParams, salesLeaderboardPersonParams } from './sales-leaderboard-drilldown-params';

@Component({
  selector: 'app-dashboard-sales-leaderboard',
  standalone: false,
  templateUrl: './dashboard-sales-leaderboard.component.html',
  styleUrls: [
    '../dashboardv2.component.scss',
    './dashboard-sales-leaderboard.component.scss',
  ],
  providers: [DashboardSalesLeaderboardStore],
})
export class DashboardSalesLeaderboardComponent {

  readonly tableColumns: SalesLeaderboardColumn[] = SALES_LEADERBOARD_COLUMNS;

  roleOptions: { label: SalesLeaderboardRole; value: SalesLeaderboardRole }[] =
    salesLeaderboardRoles.map((role) => ({ label: role, value: role }));

  viewModel$ = this.slStore.salesLeaderboardViewModel$;

  setRole = this.dashboardStore.setRole;
  triggerReload = this.dashboardStore.triggerReload;

  /** Tracks the table column index currently under the cursor for column highlight. */
  hoveredColIndex: number | null = null;

  @HostBinding('class.dark-podium')
  get isDark() { return this.colorScheme.darkMode; }

  constructor(
    private readonly dashboardStore: DashboardStore,
    private readonly slStore: DashboardSalesLeaderboardStore,
    private readonly router: Router,
    readonly colorScheme: ColorSchemeService,
  ) {}

  toggleSort(key: string, currentKey: string, currentDesc: boolean): void {
    if (!salesLeaderboardSortKeys.includes(key as typeof salesLeaderboardSortKeys[number])) return;
    if (currentKey === key) {
      this.dashboardStore.setSalesLeaderboardSortDesc(!currentDesc);
    } else {
      this.dashboardStore.setSalesLeaderboardSortKey(key as typeof salesLeaderboardSortKeys[number]);
      this.dashboardStore.setSalesLeaderboardSortDesc(true);
    }
  }

  sortIcon(key: string, activeKey: string, desc: boolean): string {
    if (key !== activeKey) return 'pi pi-sort-alt';
    return desc ? 'pi pi-sort-amount-down' : 'pi pi-sort-amount-up-alt';
  }

  // Requirement: ticket 7279 - the report page filters by jobSalesAgents / jobEstimators; the old `salesAgent`
  // param was ignored, so a name opened everyone's numbers.
  openAgentReport(userId: string | null, baseParams: Record<string, string>, role: SalesLeaderboardRole): void {
    const params: Record<string, string> = { ...baseParams, ...salesLeaderboardPersonParams(userId, role) };
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/reports', 'dynamic', 'new'], { queryParams: params }),
    );
    window.open(url, '_blank');
  }

  openMetricReport(
    col: SalesLeaderboardColumn,
    userId: string | null,
    baseParams: Record<string, string>,
    role: SalesLeaderboardRole,
  ): void {
    if (!col.drillDown) return;
    const params = buildSalesLeaderboardDrillDownParams(col.drillDown, userId, baseParams, role);
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/reports', 'dynamic', 'new'], { queryParams: params }),
    );
    window.open(url, '_blank');
  }
}
